import React, { useState } from 'react';
import { useNavigate, Link, Navigate } from 'react-router-dom';
import { Lock, Mail, LogIn, Loader2 } from 'lucide-react';
import { useAuth } from '../../lib/auth';
import { toast } from 'sonner';

export default function AdminLoginPage() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await login(email, password);
      nav('/admin');
    } catch (err) {
      toast.error(err?.response?.data?.detail || 'Login failed');
    } finally { setSubmitting(false); }
  };

  return (
    <div className="min-h-screen bg-[#0c0a08] grid lg:grid-cols-2">
      <div className="hidden lg:flex flex-col justify-between p-14 relative overflow-hidden">
        <div className="absolute -top-20 -right-20 w-[480px] h-[480px] rounded-full bg-[#f5b300]/12 blur-3xl" />
        <div className="absolute -bottom-32 -left-20 w-[440px] h-[440px] rounded-full bg-[#6b3f24]/30 blur-3xl" />
        <Link to="/" className="relative flex items-center gap-2.5 text-white">
          <span className="font-extrabold text-[22px]">WYSE<span className="text-[#f5b300]">Tribe</span></span>
        </Link>
        <div className="relative">
          <p className="text-[#f5b300] text-[12px] uppercase tracking-[0.22em] font-bold mb-3">Operations Console</p>
          <h1 className="text-white text-[44px] leading-[1.05] font-extrabold">Schedule. Plan. <br/>Grow with <span className="text-[#f5b300]">WYSE Tribe</span>.</h1>
          <p className="mt-5 text-white/65 max-w-md text-[15px] leading-relaxed">Manage every appointment, advisor, and client touch-point from one calm, professional dashboard.</p>
        </div>
        <p className="relative text-[12px] text-white/35">© {new Date().getFullYear()} WYSE Tribe – wysetribe.ca</p>
      </div>
      <div className="flex items-center justify-center p-6 lg:p-14 bg-[#f6f4ef]">
        <div className="w-full max-w-md bg-white rounded-xl shadow-[0_30px_70px_-30px_rgba(20,17,15,0.4)] p-8 md:p-10">
          <h2 className="text-[28px] font-extrabold text-[#14110f]">Welcome back</h2>
          <p className="mt-1.5 text-[14px] text-neutral-600">Sign in to your WYSE Tribe admin console.</p>
          <form onSubmit={submit} className="mt-7 space-y-4">
            <div className="relative">
              <Mail className="w-4 h-4 absolute left-3.5 top-1/2 -translate-y-1/2 text-neutral-400" />
              <input value={email} onChange={(e) => setEmail(e.target.value)} type="email" required placeholder="Email" className="w-full pl-10 pr-4 py-3.5 rounded-md border border-neutral-200 focus:border-[#f5b300] focus:ring-2 focus:ring-[#f5b300]/20 outline-none text-[14px]" />
            </div>
            <div className="relative">
              <Lock className="w-4 h-4 absolute left-3.5 top-1/2 -translate-y-1/2 text-neutral-400" />
              <input value={password} onChange={(e) => setPassword(e.target.value)} type="password" required placeholder="Password" className="w-full pl-10 pr-4 py-3.5 rounded-md border border-neutral-200 focus:border-[#f5b300] focus:ring-2 focus:ring-[#f5b300]/20 outline-none text-[14px]" />
            </div>
            <button type="submit" disabled={submitting} className="w-full inline-flex items-center justify-center gap-2 bg-[#f5b300] hover:bg-[#e0a200] disabled:opacity-60 text-[#14110f] font-semibold px-7 py-3.5 rounded-md shadow-[0_14px_30px_-10px_rgba(245,179,0,0.7)] transition-all">
              {submitting ? <Loader2 className="w-4 h-4 animate-spin" /> : <LogIn className="w-4 h-4" />} Sign in
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
